import React, { useMemo } from 'react';
import {
	Wrapper,
	Container,
	TableContainer,
	AnalysisDescription,
} from './DetailedAnalysis.styles';
import { defaultGridHeight } from './utils';
import { useSupplierSegmentationContext } from 'contexts/CategoryInsightsKpi/SupplierSegmentationProvider';
import AgGridTable from 'components/AGGridTable/AgGridTable';

const formatKeysIntoString = obj => {
	let keys = Object.keys(obj).filter(el => el !== 'SELECT');
	if (keys.length === 1) {
		return keys[0];
	} else {
		let lastKey = keys.pop();
		let formattedKeys = keys.join(', ') + ' and ' + lastKey;
		return formattedKeys;
	}
};

const SupplierSegmentationExplore = () => {
	const { gridData, types } = useSupplierSegmentationContext();
	const gridStyle = useMemo(() => defaultGridHeight, []);
	const typesString = formatKeysIntoString(types);

	return (
		<Wrapper>
			<Container>
				<AnalysisDescription>
					{`List of categories marked as ${typesString} as per the project team.`}
				</AnalysisDescription>
				<TableContainer>
					<AgGridTable gridOptions={gridData} gridStyle={gridStyle} />
				</TableContainer>
			</Container>
		</Wrapper>
	);
};

export default SupplierSegmentationExplore;
